import {
  HotelDetailResponse,
  ListHotelsResponse,
  ListPlansResponse,
} from 'tokyu-hooks/lib/response/hotel'
import { HotelDetailModel, HotelModel, HotelPlanModel } from './types'

type HotelData = ListHotelsResponse['data'][0]
type HotelPlanData = ListPlansResponse['data'][0]
type HotelDetailData = HotelDetailResponse['data']

export const toHotelModel = (hotel: HotelData): HotelModel => ({
  id: hotel.id,
  name: hotel.name,
  hotelCode: hotel.triplabot_code,
  areaName: hotel.area.name,
  triplabotCode: hotel.triplabot_code,
  hotelPhotos: hotel.hotel_photos.map((photo) => ({
    id: photo.id,
    thumbnail: photo.thumbnail,
  })),
  tel: hotel.tel,
  address: hotel.address
    ? { fullAddress: hotel.address.full_address }
    : undefined,
})

export const toHotelPlanModel = (hotelPlan: HotelPlanData): HotelPlanModel => ({
  id: hotelPlan?.id,
  name: hotelPlan?.name,
  code: hotelPlan?.code,
  images: hotelPlan?.url_plan_pictures,
})

export const toHotelDetailModel = (
  hotelPlanDetail: HotelDetailData,
): HotelDetailModel =>
  !!hotelPlanDetail
    ? {
        id: hotelPlanDetail.id,
        name: hotelPlanDetail.name,
        address: {
          fullAddress: hotelPlanDetail?.address?.full_address,
          city: hotelPlanDetail?.address?.city,
          country: hotelPlanDetail.address.country,
        },
        areaId: hotelPlanDetail?.area?.id,
        latitude: hotelPlanDetail?.latitude,
        longitude: hotelPlanDetail?.longitude,
      }
    : hotelPlanDetail
